(function () {
  'use strict';

  angular
    .module('mealDetail')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('mealDetail', {
        sticky: true,
        url: '/meal-detail',
        views: {
          'mealDetailView': {
            templateUrl: 'meal-detail/views/meal-detail.tpl.html',
            controller: 'MealDetailCtrl',
            controllerAs: 'mealDetail'
          }
        }
      });
  }
}());



